module.exports = __webpack_public_path__ + "static/img/redeem_now.c13e3d1f.png";